// libs
import { memo, useEffect } from 'react';
// helpers
import { log } from 'shared/helpers/newRelic';
import { storeUserFormKey } from 'shared/helpers/api/authFormKeyStorage';
import NFA from 'shared/helpers/analytics/NFAnalytics';

// constants
import { TAG_IDENTIFIER } from 'shared/helpers/newRelic/constants';

interface UserInitProps {
  fetchUser: () => any;
}

const UserInit = ({ fetchUser }: UserInitProps) => {
  useEffect(() => {
    const initUser = async () => {
      try {
        const data = await fetchUser();
        const { formKey, customerData, isUserFetchError, isAuthenticatedSession } = data || {};
        const {
          mobile: phone,
          email,
          firstname: firstName,
          lastname: lastName,
          id: customerId,
        } = customerData || {};

        if (customerData && Object.keys(customerData).length > 0) {
          NFA.setUserData({ phone, email, firstName, lastName, customerId });
          NFA.setIsLogin(true);
        } else if (!isUserFetchError || !isAuthenticatedSession) {
          NFA.setIsLogin(false);
        }

        if (formKey) {
          storeUserFormKey(formKey);
        }
      } catch (err) {
        log({
          errTitle: 'Error in UserInit - Boot',
          error: err,
          tags: { [TAG_IDENTIFIER.MODULE]: 'BOOT-AUTH' },
        });
        NFA.setIsLogin(false);
      }
    };
    initUser();
  }, [fetchUser]);

  return null;
};

export default memo(UserInit);
